export const BANCOS_STR_URL =
  'https://www.bcb.gov.br/content/estabilidadefinanceira/str1/ParticipantesSTR.csv';

export const BANCOS_GOLDEN_COMPE_BB = '001';
export const BANCOS_GOLDEN_COMPE_ITAU = '341';
export const BANCOS_GOLDEN_COMPE_NUBANK = '260';

export const BANCOS_GOLDEN_ISPB_BB = '00000000';
export const BANCOS_GOLDEN_ISPB_ITAU = '60701190';
export const BANCOS_GOLDEN_ISPB_NUBANK = '18236120';

export const BANCOS_MIN_INSTITUTIONS = 250;
export const BANCOS_MAX_INSTITUTIONS = 500;
